export const enumClaims = {
  Главная: "Главная",
  Товары: "Товары",
  Каталог: "Каталог",
  "Может удалять товары": "Может удалять товары",
  Категории: "Категории",
  "Создание категории": "Создание категории",
  Аналитика: "Аналитика",
  "Отзывы и сообщения": "Отзывы и сообщения",
  "Управление ценами": "Управление ценами",
  "Склад и остатки": "Склад и остатки",
  Склады: "Склады",
  Остатки: "Остатки",
  Заказы: "Заказы",
  Настройки: "Настройки",
  Организации: "Организации",
  Интеграции: "Интеграции",
  Сотрудники: "Сотрудники",
  Этикетки: "Этикетки",
  "Управление остатками": "Может включать и отключать управление остатками",
  "Со своего склада FBS": "Со своего склада FBS",
  "Имеет доступ к финансовой информации":
    "Имеет доступ к финансовой информации",
  Логи: "Логи",
  Короба: "Короба",
  Поставки: "Поставки",
  "Может отменять заказы FBS": "Может отменять заказы FBS",
  "Объединение товаров": "Объединение товаров",
};
